import { memo, useState } from "react";
import Demo from "./Demo/Demo";
import Name from "./Name/Name";
import Highlight from "./Highlight/Highlight";
import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";
import Actions from "./Actions/Actions";
import FixaCheckbox from "@coworker/apprestructured/src/shared/wrappers/FixaCheckbox/FixaCheckbox";
import { Files } from "@coworker/apprestructured/src/task-management/components/Files/Files";

const mockFiles: File[] = [
  new File(["This is the content of a text file"], "document.txt", {
    type: "text/plain",
    lastModified: Date.now(),
  }),
  new File(
    [JSON.stringify({ key: "value", array: [1, 2, 3] }, null, 2)],
    "data.json",
    { type: "application/json", lastModified: Date.now() }
  ),
  new File(["Name,Age,City\nJohn Doe,30,San Francisco"], "info.csv", {
    type: "text/csv",
    lastModified: Date.now(),
  }),
];

function FilesDemo() {
  const [disabled, setDisabled] = useState(false);

  return (
    <Demo>
      <Name>Files</Name>
      <Highlight>
        <FixaListView id="filesdemo" size="small">
          <Files files={mockFiles} disabled={disabled} />
        </FixaListView>
      </Highlight>
      <Actions>
        <FixaCheckbox
          label="disabled"
          value="filesdemo-disabled"
          id="filesdemo-disabled"
          checked={disabled}
          onChange={() => setDisabled((prev) => !prev)}
        />
      </Actions>
    </Demo>
  );
}

export default memo(FilesDemo);
